import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Preloader } from './components/Preloader';
import { Hero } from './components/Hero';
import { Welcome } from './components/Welcome';
import { Destinations } from './components/Destinations';
import { Training } from './components/Training';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  const [isLoading, setIsLoading] = useState(true);
  return <div className="min-h-screen bg-zinc-950 font-sans text-white selection:bg-blue-900 selection:text-white" data-id="element-0" data-mp="2mmvlkvs92ic2">
      <AnimatePresence data-id="element-1" data-mp="31bi9vmzuukff">
        {isLoading && <Preloader onComplete={() => setIsLoading(false)} data-id="element-2" data-mp="31cjou2jzrr2f" />}
      </AnimatePresence>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: isLoading ? 0 : 1
    }} transition={{
      duration: 1,
      ease: 'easeInOut'
    }} data-id="element-3" data-mp="2whx9xpepbgdl">
        <Hero data-id="element-4" data-mp="3ik7fce9tu7pl" />
        <Welcome data-id="element-5" data-mp="3ikqzm1my986s" />
        <Destinations data-id="element-6" data-mp="3ij64oawq3n8e" />
        <Training data-id="element-7" data-mp="3ijpe138b53at" />
        <Footer data-id="element-8" data-mp="3ii4qhxkeukmg" />
      </motion.div>
    </div>;
}